import {useMockState} from '@resurs-internal/rb-app-api';
import {Box, Typography} from '@mui/material';
import React from 'react';
import {useDialog, useIsMobile, useTranslate} from '../../hooks';

export const DemoBanner = () => {
  const mock = useMockState();
  const translate = useTranslate();
  const dialog = useDialog('demo');
  const isMobile = useIsMobile();

  return (
    <Box
      aria-hidden
      onClick={() => dialog.setOpen(true)}
      sx={{
        display: mock.mode ? undefined : 'none',
        position: 'fixed',
        cursor: 'pointer',
        zIndex: 100,
        top: 0,
        right: 0,
        transform: 'rotate(45deg)',
        marginTop: isMobile ? 2 : 4,
        marginRight: isMobile ? -10 : -8,
      }}>
      <Box
        sx={(theme) => ({
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: 240,
          height: 40,
          backgroundColor: theme.palette.error.main,
          color: theme.palette.background.paper,
        })}>
        <Typography>{translate('demo.banner')}</Typography>
      </Box>
    </Box>
  );
};
